var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { DataContext } from '@philips-internal/oswald-ui-core/lib/component/context/index.js';
import { arrayOf, number, object, oneOfType, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { ChangeEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { isEmptyValue, isEqualShallow, isFunction, isUndefined } from '@philips-internal/oswald-ui-utils';
import { Autocomplete } from '../autocomplete/autocomplete.js';
import { UnboxedAutocompleteAPI } from './unboxed-autocomplete-api.js';
import { fetchLocalRecords, fetchRecords } from './unboxed-autocomplete-utils.js';
let UnboxedAutocomplete = class UnboxedAutocomplete extends Component {
    constructor() {
        super(...arguments);
        this.state = {};
        this.onAutocompleteChange = (event) => {
            const { primaryKey, onChange, value: oldValue } = this.props;
            const { value } = event;
            if (!isFunction(onChange)) {
                return;
            }
            let changeValue = undefined;
            if (!isUndefined(value)) {
                if (Array.isArray(value)) {
                    changeValue = value.map((value) => value[primaryKey]);
                }
                else {
                    changeValue = value[primaryKey];
                }
            }
            onChange(new ChangeEvent({
                oldValue,
                prettyValue: this.getDescriptionValue(),
                value: changeValue,
            }));
        };
    }
    componentDidMount() {
        const { localData } = this.props;
        if (localData) {
            this.fetchLocalRecords();
        }
        else {
            this.fetchRecords();
        }
    }
    componentDidUpdate(prevProps) {
        const { data, localData, value } = this.props;
        const { data: prevData, value: prevValue } = prevProps;
        if (isEqualShallow({ data, value }, { data: prevData, value: prevValue })) {
            return;
        }
        if (isEmptyValue(value) && !isEmptyValue(prevValue)) {
            /**
             * Setting records as undefined here because an empty array will not have effect because in Autocomplete componentDidUpdate has a check comparing prevValue and value and
             * as the fetchRecords returns a empty array if the endpoint is not ready or the value prop is undefined, the prevValue and value could be
             * equal in some moments resulting in not cleaning the internalValue.
             */
            return this.setState({ records: undefined });
        }
        if (localData) {
            this.fetchLocalRecords();
        }
        else {
            this.fetchRecords();
        }
    }
    getDescriptionValue() {
        const { entry, formatters, multiselect, previewAmount } = this.props;
        const { records } = this.state;
        return Autocomplete.formatPrettyValue({ entry, formatters, multiselect, previewAmount, value: records }) || '';
    }
    fetchRecords() {
        const { endpoint, parameters, primaryKey, value } = this.props;
        const options = {
            endpoint,
            parameters,
            primaryKey,
            value,
        };
        void fetchRecords(options, this.context)
            .then((records) => {
            this.setState({ records });
        });
    }
    fetchLocalRecords() {
        const { data, localData, primaryKey, value } = this.props;
        if (!localData || !value) {
            return;
        }
        const options = {
            primaryKey,
            value,
        };
        const records = fetchLocalRecords(options, data);
        this.setState({ records });
    }
    render() {
        const { children, ...otherProps } = this.props;
        const { records } = this.state;
        return (React.createElement(Autocomplete, { ...otherProps, onChange: this.onAutocompleteChange, value: records }, children));
    }
};
UnboxedAutocomplete.contextType = DataContext.Context;
UnboxedAutocomplete.propTypes = {
    ...Autocomplete.propTypes,
    endpoint: string.notEnumerable(),
    parameters: object.notEnumerable(),
    value: oneOfType([string, number, arrayOf(oneOfType([string, number]))]),
};
UnboxedAutocomplete.defaultProps = {
    ...Autocomplete.defaultProps,
    endpoint: '',
    parameters: {},
};
UnboxedAutocomplete = __decorate([
    AwesomeComponent({ api: UnboxedAutocompleteAPI, type: ComponentType.BEHAVIOR })
], UnboxedAutocomplete);
export { UnboxedAutocomplete, };
//# sourceMappingURL=unboxed-autocomplete.js.map